import React, { useState, useEffect, useRef } from 'react';

const Testimonials = () => {
  const [currentIndex, setCurrentIndex] = useState(0);
  const [isAutoPlaying, setIsAutoPlaying] = useState(true);
  const [isVisible, setIsVisible] = useState(false);
  const sectionRef = useRef(null);

  const testimonials = [
    {
      id: 1,
      name: "Diego Vidaurre",
      title: "CEO and Co-Founder",
      company: "The Beacon",
      comment: "Working with YP has been pivotal for The Beacon's success. From AMAs to Livestreams to being featured live on some of the most prominent events in the industry. YP's traction is undeniable as one of the most influential figures of Web3 gaming.",
      photo: "/images/diego.jpg",
      rating: 5
    },
    {
      id: 2,
      name: "Paul Delio",
      title: "CBO",
      company: "CARV",
      comment: "CARV has been working together with YP and GG for over a year and can't speak highly enough about the quality of their team and expertise. Throughout scaling community, $50M node sales, and post TGE, the team went above and beyond to deliver on their promise of maximizing reach while being cost efficient. I can't recommend working with them enough.",
      photo: "/images/paul.jpg",
      rating: 5
    },
    {
      id: 3,
      name: "KB",
      title: "Co-Founder",
      company: "OVERTAKE",
      comment: "Working with Gaming Grid, Asia's #1 gaming guild, has been a powerhouse partnership, connecting OVERTAKE with a vibrant community of Web3 gamers and builders. Together with YP, a visionary founder and OVERTAKE advisor, we've built momentum bridging competitive gaming and digital ownership. The collaboration embodies the spirit of scale, culture, and innovation we're driving at OVERTAKE.",
      photo: "/images/kb.jpg",
      rating: 5
    }
  ];

  // Intersection Observer for fade-in animation
  useEffect(() => {
    const observer = new IntersectionObserver(
      ([entry]) => {
        if (entry.isIntersecting) {
          setIsVisible(true);
          observer.unobserve(entry.target);
        }
      },
      {
        threshold: 0.3,
        rootMargin: '0px 0px -50px 0px'
      }
    );

    const currentRef = sectionRef.current;
    if (currentRef) {
      observer.observe(currentRef);
    }

    return () => {
      if (currentRef) {
        observer.unobserve(currentRef);
      }
    };
  }, []);

  // Auto-play functionality
  useEffect(() => {
    if (!isAutoPlaying) return;

    const interval = setInterval(() => {
      setCurrentIndex((prevIndex) =>
        prevIndex === testimonials.length - 1 ? 0 : prevIndex + 1
      );
    }, 5000);

    return () => clearInterval(interval);
  }, [isAutoPlaying, testimonials.length]);

  const nextTestimonial = () => {
    setCurrentIndex((prevIndex) =>
      prevIndex === testimonials.length - 1 ? 0 : prevIndex + 1
    );
  };

  const prevTestimonial = () => {
    setCurrentIndex((prevIndex) =>
      prevIndex === 0 ? testimonials.length - 1 : prevIndex - 1
    );
  };

  const goToTestimonial = (index) => {
    setCurrentIndex(index);
  };

  const StarRating = ({ rating }) => {
    return (
      <div className="star-rating">
        {[...Array(5)].map((_, index) => (
          <span
            key={index}
            className={`star ${index < rating ? 'filled' : ''}`}
          >
            ★
          </span>
        ))}
      </div>
    );
  };

  return (
    <section className="testimonials-new" ref={sectionRef}>
      <div className="container">
        {/* New Header Design */}
        <div className={`section-header-new ${isVisible ? 'visible' : ''}`}>
          <div className="header-top">
            <div className="header-accent"></div>
            <h2>What Our Partners Say</h2>
            <div className="header-accent"></div>
          </div>
          <p className="header-subtitle">Trusted by gaming studios and Web3 projects worldwide</p>
        </div>

        {/* New Testimonial Layout */}
        <div
          className={`testimonials-container ${isVisible ? 'visible' : ''}`}
          onMouseEnter={() => setIsAutoPlaying(false)}
          onMouseLeave={() => setIsAutoPlaying(true)}
        >
          {/* Main Testimonial Card */}
          <div className="testimonial-main">
            <div className="testimonial-content">
              {/* Quote Icon */}
              {/* <div className="quote-icon">
                <svg width="32" height="32" viewBox="0 0 24 24" fill="currentColor">
                  <path d="M4.583 17.321C3.553 16.227 3 15 3 13.011c0-3.5 2.457-6.637 6.03-8.188l.893 1.378c-3.335 1.804-3.987 4.145-4.247 5.621.537-.278 1.24-.375 1.929-.311 1.804.167 3.226 1.648 3.226 3.489a3.5 3.5 0 0 1-3.5 3.5c-1.073 0-2.099-.49-2.748-1.179zm10 0C13.553 16.227 13 15 13 13.011c0-3.5 2.457-6.637 6.03-8.188l.893 1.378c-3.335 1.804-3.987 4.145-4.247 5.621.537-.278 1.24-.375 1.929-.311 1.804.167 3.226 1.648 3.226 3.489a3.5 3.5 0 0 1-3.5 3.5c-1.073 0-2.099-.49-2.748-1.179z"/>
                </svg>
              </div> */}

              {/* Testimonial Text */}
              <blockquote className="testimonial-text">
                {testimonials[currentIndex].comment}
              </blockquote>

              {/* Client Info */}
              <div className="client-info-main">
                <div className="client-avatar">
                  <img
                    src={testimonials[currentIndex].photo}
                    alt={testimonials[currentIndex].name}
                    onError={(e) => {
                      e.target.style.display = 'none';
                      e.target.nextSibling.style.display = 'flex';
                    }}
                  />
                  <div className="avatar-placeholder">
                    {testimonials[currentIndex].name.split(' ').map(n => n[0]).join('')}
                  </div>
                </div>
                <div className="client-details">
                  <div className="client-name">{testimonials[currentIndex].name}</div>
                  <div className="client-title">{testimonials[currentIndex].title}</div>
                  <div className="client-company">{testimonials[currentIndex].company}</div>
                </div>
              </div>

              {/* Rating */}
              <StarRating rating={testimonials[currentIndex].rating} />
            </div>
          </div>

          {/* Navigation Controls */}
          <div className="testimonial-controls">
            <button
              className="control-btn prev-btn"
              onClick={prevTestimonial}
              aria-label="Previous testimonial"
            >
              <svg width="20" height="20" viewBox="0 0 24 24" fill="currentColor">
                <path d="M15.41 7.41L14 6l-6 6 6 6 1.41-1.41L10.83 12z" />
              </svg>
            </button>

            {/* Indicators */}
            <div className="testimonial-indicators">
              {testimonials.map((_, index) => (
                <button
                  key={index}
                  className={`indicator ${index === currentIndex ? 'active' : ''}`}
                  onClick={() => goToTestimonial(index)}
                  aria-label={`Go to testimonial ${index + 1}`}
                >
                  <span className="indicator-progress"></span>
                </button>
              ))}
            </div>

            <button
              className="control-btn next-btn"
              onClick={nextTestimonial}
              aria-label="Next testimonial"
            >
              <svg width="20" height="20" viewBox="0 0 24 24" fill="currentColor">
                <path d="M10 6L8.59 7.41 13.17 12l-4.58 4.59L10 18l6-6z" />
              </svg>
            </button>
          </div>
        </div>
      </div>
    </section>
  );
};

export default Testimonials;